import { render, staticRenderFns } from "./add_register.vue?vue&type=template&id=12d0b63e&scoped=true"
import script from "./add_register.vue?vue&type=script&lang=js"
export * from "./add_register.vue?vue&type=script&lang=js"
import style0 from "./add_register.vue?vue&type=style&index=0&id=12d0b63e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d0b63e",
  null
  
)

export default component.exports